module.exports = __webpack_public_path__ + "img/star_on.b59299e6.svg";